import { Helmet } from "@/lib/helmet";
import { useSiteSettings } from '@/hooks/useSiteSettings';

interface LanguageWrapperProps {
  children: React.ReactNode;
}

export const LanguageWrapper = ({ children }: LanguageWrapperProps) => {
  const { data: siteSettings } = useSiteSettings();
  
  const language = siteSettings?.language || 'de';

  return (
    <>
      <Helmet htmlAttributes={{ lang: language }} />
      {children}
    </>
  );
};
